import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import {
  getEmailSettingList,
  changeItemCheck
} from 'src/reducers/admin_email_notification_settings/admin_email_notification_settings';
import { withTranslation, useTranslation } from 'react-i18next';

const EDIT_MODE = 'EDIT';

const CheckBoxComponent = ({ item, field, editing, checkItem }) => {
  const { t } = useTranslation();
  return (
    <td>
      {editing ? (
        <label className="input-label">
          <input
            type="checkbox"
            checked={_.get(item, field)}
            onChange={() => checkItem(item, field)}
            className="m-checkbox-input"
          />
          <span className="m-checkbox-parts">{t('features.AdminEmailNotificationSetting.components.EmailNotificationSettingTable.receive')}</span>
        </label>
      ) : _.get(item, field) ? (
        t('features.AdminEmailNotificationSetting.components.EmailNotificationSettingTable.receive')
      ) : (
        t('features.AdminEmailNotificationSetting.components.EmailNotificationSettingTable.do_not_recieve')
      )}
    </td>
  );
};

const Row = ({ item, editing, checkItem }) => (
  <tr>
    <td style={{ wordWrap: 'break-word' }}>{item.email}</td>
    <td style={{ wordWrap: 'break-word' }}>{item.name}</td>
    <CheckBoxComponent {...{ item, editing, checkItem }} field="canReceiveAttendanceMail" />
    <CheckBoxComponent {...{ item, editing, checkItem }} field="canReceiveEmployeeMail" />
    <CheckBoxComponent {...{ item, editing, checkItem }} field="canReceiveConfirmPayMail" />
    <CheckBoxComponent {...{ item, editing, checkItem }} field="canReceiveDownloadAllowanceMail" />
  </tr>
);

class EmailNotificationSettingTable extends Component {
  render() {
    const { emailSettingList, mode, checkItem } = this.props;
    const editing = mode === EDIT_MODE;

    return (
      <div className="l-overflow-scroll">
        <table className="m-table-list m-table-fixed">
          <colgroup>
            <col width={190} />
            <col width={190} />
            <col width={140} />
            <col width={140} />
            <col width={140} />
            <col width={160} />
          </colgroup>
          <thead>
            <tr>
              <th>{this.props.t('features.AdminEmailNotificationSetting.components.EmailNotificationSettingTable.Email')}</th>
              <th>{this.props.t('features.AdminEmailNotificationSetting.components.EmailNotificationSettingTable.Name')}</th>
              <th>{this.props.t('features.AdminEmailNotificationSetting.components.EmailNotificationSettingTable.Attendance_information')}</th>
              <th>{this.props.t('features.AdminEmailNotificationSetting.components.EmailNotificationSettingTable.Employee_information')}</th>
              <th>{this.props.t('features.AdminEmailNotificationSetting.components.EmailNotificationSettingTable.Salary_bonus_confirmation')}</th>
              <th>{this.props.t('features.AdminEmailNotificationSetting.components.EmailNotificationSettingTable.Provision_and_deduction_download')}</th>
            </tr>
          </thead>
          <tbody>{_.map(emailSettingList, item => <Row {...{ item, editing, checkItem }} key={item.id} />)}</tbody>
        </table>
      </div>
    );
  }
}

export default withTranslation('translation')(connect(
  state => ({
    emailSettingList: getEmailSettingList(state) || []
  }),
  dispatch => ({
    checkItem: (item, field) => dispatch(changeItemCheck(item, field))
  })
)(EmailNotificationSettingTable));
